import Movies from "../Movies";
import ProfileIcon from "./ProfileIcon";
import PageChooseProfile from "./PageChooseProfile";
import Pulse from "src/Component/Pulse";
import profiles from "../profiles.json";
import useClock from "../../../Hooks/useClock";

import "./index.sass";
import Config from "src/Constants/Config";

interface HomePageProps {
  currentUser: string;
  setCurrentUser: (user: string) => void;
  continueWatching: MovieType[];
  step: number;
  pageId: number;
  stepVisited: number[];
  setStep: (step: number) => void;
}

const HomePage = ({ currentUser, pageId, setCurrentUser, continueWatching, step, stepVisited, setStep }: HomePageProps) => {
  const time = useClock();
  const currentProfile = profiles.find((profile) => profile.key === currentUser);

  return (
    <div id="homepage-tv">
      {!stepVisited.includes(1) && pageId !== 4 && (
        <Pulse style={{ position: "absolute", top: "calc(-1 * var(--height-12))", right: "var(--width-20)" }} />
      )}
      <div className="time">{time}</div>

      <img className="home-movie" src={`${Config.BASE_URL}/images/screen_3/${currentProfile?.homepage}`} alt="" />

      <ProfileIcon
        handleOnClick={() => setStep(1)}
        color={currentProfile?.color}
        style={{
          position: "absolute",
          top: "var(--height-48)",
          right: "var(--width-80)",
          width: "var(--width-30)",
          height: "var(--height-30)",
        }}
      />
      <img className="homepage-dots" src={`${Config.BASE_URL}/images/screen_3/dots.png`} alt="" />
      <Movies
        showGradient={pageId === 4}
        showProvider={true}
        className="homepage-movies"
        title="Continue Watching"
        data={continueWatching}
        handleOnClickPulse={() => setStep(2)}
      />

      <PageChooseProfile
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        step={step}
        stepVisited={stepVisited}
        setStep={setStep}
      />
    </div>
  );
};

export default HomePage;
